import React, { useState, useEffect } from 'react';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import { BiUser } from 'react-icons/bi';

const FAQs = () => {

  useEffect(() => {
    document.title = "Island Luxury - FAQs"
  }, [])

  const [accordion, setAccordion] = useState(false)

  const faqs = [
    {
      title: "Is Island Luxury Property Listings an Estate Agent?",
      content: "We are not estate agent, but IslandLuxuryPropertyListings is a place where Nigerian property seekers can find information of all available properties to buy or rent."
    },
    {
      title: "Is Island Luxury Property Listings an Estate Agent?",
      content: "We are not estate agent, but IslandLuxuryPropertyListings is a place where Nigerian property seekers can find information of all available properties to buy or rent."
    },
    {
      title: "Is Island Luxury Property Listings an Estate Agent?",
      content: "We are not estate agent, but IslandLuxuryPropertyListings is a place where Nigerian property seekers can find information of all available properties to buy or rent."
    },
    {
      title: "Is Island Luxury Property Listings an Estate Agent?",
      content: "We are not estate agent, but IslandLuxuryPropertyListings is a place where Nigerian property seekers can find information of all available properties to buy or rent."
    },
    {
      title: "Is Island Luxury Property Listings an Estate Agent?",
      content: "We are not estate agent, but IslandLuxuryPropertyListings is a place where Nigerian property seekers can find information of all available properties to buy or rent."
    }
  ]

  return (
    <div id="faqs">
      <Header />
      <main>
        <section className="intro-area">
          <div className="intro-area_wrap container">
            <h1>FAQs</h1>
          </div>
        </section>
        <section className="faq-accordions container">
          {/* {faqs.map((item, i) => 
            <div key={i} className="faq-accordion">
              <button className="accordion-header" onClick={() => setAccordion(!accordion)}>
                <h2>{item.title}</h2>
                <BiUser />
              </button>
              {accordion && <div className="accordion-body">{item.content}</div>}
            </div>
          )} */}
        </section>
        <Footer />
      </main>
    </div>
  )
}

export default FAQs;